export const CACHE_KEY_ORGANIZATION_EDIT_PAYMENT = 'organization-edit-payment';
